module.exports = __webpack_public_path__ + "static/media/book1.6c50ffa2.jpg";